const THRESHOLD_CENTS = 15000;
const POLL_INTERVAL_MS = 1200;

let hasCelebrated = false;
let lastKnownTotal = null;
let pollTimer = null;

function celebrate() {
  const bar = document.querySelector('.cart-free-shipping');
  const marker = bar?.querySelector('.cart-free-shipping__marker') || bar;
  if (marker) {
    marker.classList.add('cart-free-shipping__marker--pulse');
    setTimeout(() => marker.classList.remove('cart-free-shipping__marker--pulse'), 900);
  }

  // Append inside the open <dialog> so the confetti shares its top-layer
  // stacking context and isn't painted underneath the modal.
  const host = document.getElementById('cart-drawer')?.querySelector('dialog') ?? document.body;
  const hostRect = host.getBoundingClientRect();
  const edgeX = hostRect.right;
  const centerY = hostRect.top + hostRect.height / 2;

  // A confetti cannon sitting at the drawer's edge: every piece launches from
  // roughly the same nozzle point and scatters outward into a leftward cone
  // at an independently random angle and distance, so the spread looks like
  // a genuine burst rather than a geometric fan.
  const maxReachPx = hostRect.width + 378; // ~10cm past the drawer at most
  const coneAngleDeg = 55; // degrees of scatter above/below straight-left

  const colors = ['#f5b400', '#3a6b35', '#e63946', '#457b9d', '#a663cc'];
  const pieceCount = 280;

  for (let i = 0; i < pieceCount; i++) {
    const piece = document.createElement('span');
    piece.className = 'cart-free-shipping__confetti-piece';

    // Nozzle: a small cluster, not spread across the drawer's height.
    const originX = edgeX + Math.random() * 10;
    const originY = centerY + (Math.random() - 0.5) * 60;

    // Independent random angle and distance for a natural, chaotic scatter.
    const thetaDeg = (Math.random() * 2 - 1) * coneAngleDeg;
    const thetaRad = (thetaDeg * Math.PI) / 180;
    const radius = maxReachPx * (0.25 + Math.random() * 0.75);

    const burstX = -radius * Math.cos(thetaRad);
    const burstY = -radius * Math.sin(thetaRad) * 0.7;

    // Phase 2: gravity pulls the piece down and it keeps drifting sideways.
    const fallX = burstX + (Math.random() * 90 - 20);
    const fallY = burstY + 220 + Math.random() * 260;

    const size = 3 + Math.random() * 3;

    piece.style.left = `${originX}px`;
    piece.style.top = `${originY}px`;
    piece.style.width = `${size}px`;
    piece.style.height = `${size * 1.7}px`;
    piece.style.setProperty('--burst-x', `${burstX}px`);
    piece.style.setProperty('--burst-y', `${burstY}px`);
    piece.style.setProperty('--fall-x', `${fallX}px`);
    piece.style.setProperty('--fall-y', `${fallY}px`);
    piece.style.setProperty('--burst-rotate', `${Math.random() * 240 - 120}deg`);
    piece.style.setProperty('--fall-rotate', `${Math.random() * 900 + 300 * (Math.random() < 0.5 ? -1 : 1)}deg`);
    piece.style.setProperty('--delay', `${Math.random() * 0.25}s`);
    piece.style.background = colors[Math.floor(Math.random() * colors.length)];
    piece.addEventListener('animationend', () => piece.remove());
    host.appendChild(piece);
  }
}

async function pollCart() {
  try {
    // Only relevant where the free-shipping bar itself is rendered (Germany
    // only, per cart-free-shipping-bar.liquid). No bar, no confetti.
    if (!document.querySelector('.cart-free-shipping')) return;

    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) return;
    const cart = await response.json();

    const wasBelow = lastKnownTotal !== null && lastKnownTotal < THRESHOLD_CENTS;
    const isAtOrAbove = cart.total_price >= THRESHOLD_CENTS;

    if (isAtOrAbove && (wasBelow || (lastKnownTotal === null && !hasCelebrated))) {
      hasCelebrated = true;
      celebrate();
    } else if (!isAtOrAbove) {
      hasCelebrated = false;
    }

    lastKnownTotal = cart.total_price;
  } catch (e) {}
}

// Only poll while the cart drawer is actually open — this ran unconditionally
// forever before, hitting /cart.js every 1.2s in the background on every page
// even while the drawer was closed, for the entire session. Tying it to the
// drawer's own open/close events cuts that background load to (near) zero.
function startPolling() {
  if (pollTimer !== null) return;
  pollCart();
  pollTimer = setInterval(pollCart, POLL_INTERVAL_MS);
}

function stopPolling() {
  if (pollTimer === null) return;
  clearInterval(pollTimer);
  pollTimer = null;
}

document.addEventListener('theme-drawer:open', (event) => {
  if (event.target?.id !== 'cart-drawer') return;
  startPolling();
});

document.addEventListener('theme-drawer:close', (event) => {
  if (event.target?.id !== 'cart-drawer') return;
  stopPolling();
});

// Cover the case where the drawer is already open when this module loads
// (e.g. restored on back-navigation, before this script re-registers).
if (document.getElementById('cart-drawer')?.querySelector('dialog')?.open) {
  startPolling();
}
